import { BackendRoute } from '../../../../config/index';
import { QueryKey } from '../../../../constants/index';
import { useInvalidateQueries } from '../../../../hooks/index';
import { useAppQuery } from '../../../../hooks/use-app-query.hook';
import { ApiService } from '../../../../services/index';
import { Order } from '../../../../types/general.types';
import { Perk, PerkClaimType } from '../perks.types';
import { PerksColumn, perksColumnSortMap, PerkStatusFilterUnion } from '../table.types';

export type PerkSortByPayload = { field: null | PerksColumn; order: null | Order };

type Props = {
  filter?: PerkStatusFilterUnion;
  search?: string;
  skip?: number;
  sort?: PerkSortByPayload;
  take?: number;
  type?: PerkClaimType;
};

export const usePerks = ({ filter, search, skip, sort, take, type }: Props = {}) => {
  const { invalidateQuery } = useInvalidateQueries(QueryKey.PERKS, QueryKey.GET);

  const {
    data: { records = [], count = 0, totalPages = 1 } = {},
    isLoading,
    isFetched,
  } = useAppQuery({
    queryKey: [QueryKey.PERKS, QueryKey.GET, { search, take, skip, filter, sort, type }],
    queryFn: () =>
      ApiService.get<{
        count: number;
        records: Perk[];
        totalPages: number;
      }>(
        {
          endpoint: BackendRoute.PERKS,
          routePath: ['admin'],
        },
        {
          regularBackend: true,
          queryParams: {
            search,
            take,
            skip,
            filter,
            orderBy: sort?.field ? perksColumnSortMap[sort.field] : undefined,
            order: sort?.order || undefined,
            type,
          },
        },
      ),
  });

  return {
    invalidateQuery,
    records,
    isLoading,
    totalPages,
    totalRecords: count,
    isFetched,
  };
};
